import { useIntl } from 'react-intl';
import { useLocation } from 'wouter';
import { useRecoilValue } from 'recoil';
import { URL_TRIPS_OVERVIEW } from '../../../router/constants';
import PermissionsService, { PERMISSION_NEW_RIDE } from '../../../Services/PermissionsService';
import showMessage from '../../Toastr/ToastService';
import { NEW_RIDE_ACTION } from '../constants';
import { selectedVehiclesWithBasicInfoSelector } from '../../../store/recoil/vehicles';
import { VehiclesBasicInfo } from '../../Vehicles/types';

interface INewRideProps {
  handleAction: (action: string) => void;
}

function AddButton(props: INewRideProps): JSX.Element | null {
  const { formatMessage: f } = useIntl();
  const selectedVehicles = useRecoilValue<VehiclesBasicInfo>(selectedVehiclesWithBasicInfoSelector);
  const [, navigate] = useLocation();

  const handleAddForm = () => {
    if (Object.keys(selectedVehicles).length > 0) {
      props.handleAction(NEW_RIDE_ACTION);
      navigate(`${URL_TRIPS_OVERVIEW}/add`);
    } else {
      showMessage(
        f({ id: 'toastr.warning' }),
        f({ id: 'tripsOverview.modal.newRide.vehicleId.error' }),
        'warning'
      );
    }
  };

  const isButtonEnabled = (): boolean => {
    const isEnabled: boolean[] = [];
    const vehicleKeys = Object.keys(selectedVehicles);
    if (vehicleKeys.length === 0) {
      isEnabled.push(false);
    }
    vehicleKeys.forEach((vehicleId: string) => {
      const selectedVehicle = selectedVehicles[Number(vehicleId)];
      if (selectedVehicle) {
        isEnabled.push(
          PermissionsService.hasAccess(PERMISSION_NEW_RIDE, ['create'], selectedVehicle.customerId)
        );
      }
    });
    return !isEnabled.includes(false);
  };

  if (isButtonEnabled()) {
    return (
      <button
        type="button"
        key="trips-overview-add-btn"
        data-cy="trips-overview-add-btn"
        title={f({ id: `tripsOverview.button.newRide` })}
        className="add-new-ride-button"
        onClick={handleAddForm}
        style={{ marginRight: '7px' }}
      >
        {f({ id: `tripsOverview.button.newRide` })}
      </button>
    );
  }

  return null;
}

export default AddButton;
